<h1 mat-dialog-title>{{ data.log.log_type + " - " + data.log.entity + " #" + data.log.entity_id }}</h1>
<div mat-dialog-content>
    <div class="details mt-3">
        <div [ngSwitch]="data.log.entity">
            <table *ngSwitchCase="EntityType.Address">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Apartment number</th>
                    <td>{{oldValue.building_apt_number}}</td>
                    <td>{{newValue.building_apt_number}}</td>
                </tr>


                <tr>
                    <th>Address 1</th>
                    <td>{{oldValue.address_1}}</td>
                    <td>{{newValue.address_1}}</td>
                </tr>

                <tr>
                    <th>Address 2</th>
                    <td>{{oldValue.address_2}}</td>
                    <td>{{newValue.address_2}}</td>
                </tr>

                <tr>
                    <th>Postcode</th>
                    <td>{{oldValue.postcode}}</td>
                    <td>{{newValue.postcode}}</td>
                </tr>

                <tr>
                    <th>Country</th>
                    <td>{{oldValue.country}}</td>
                    <td>{{newValue.country}}</td>
                </tr>

                <tr>
                    <th>Individual ID</th>
                    <td>{{oldValue.individual_id}}</td>
                    <td>{{newValue.individual_id}}</td>
                </tr>


                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.Batch">
                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Quantity produced</th>
                    <td>{{oldValue.quantity_produced}}</td>
                    <td>{{newValue.quantity_produced}}</td>
                </tr>

                <tr>
                    <th>Batch number</th>
                    <td>{{oldValue.batch_number}}</td>
                    <td>{{newValue.batch_number}}</td>
                </tr>

                <tr>
                    <th>BatchStatus ID</th>
                    <td>{{oldValue.batch_status_id}}</td>
                    <td>{{newValue.batch_status_id}}</td>
                </tr>

                <tr>
                    <th>MedicineDosageType ID</th>
                    <td>{{oldValue.medicine_dosage_type_id}}</td>
                    <td>{{newValue.medicine_dosage_type_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>


            </table>

            <table *ngSwitchCase="EntityType.BatchItem">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Barcode</th>
                    <td>{{oldValue.barcode}}</td>
                    <td>{{newValue.barcode}}</td>
                </tr>

                <tr>
                    <th>In stock</th>
                    <td>{{oldValue.in_stock === 1 ? 'Yes' : 'No' }}</td>
                    <td>{{newValue.in_stock === 1 ? 'Yes' : 'No'}}</td>
                </tr>

                <tr>
                    <th>Order Item ID</th>
                    <td>{{oldValue.order_item_id}}</td>
                    <td>{{newValue.order_item_id}}</td>
                </tr>


                <tr>
                    <th>Batch Package ID</th>
                    <td>{{oldValue.batch_package_id}}</td>
                    <td>{{newValue.batch_package_id}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.BatchStatus">
                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Status</th>
                    <td>{{oldValue.status}}</td>
                    <td>{{newValue.status}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.Company">
                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Name</th>
                    <td>{{oldValue.name}}</td>
                    <td>{{newValue.name}}</td>
                </tr>


                <tr>
                    <th>Email address</th>
                    <td>{{oldValue.email}}</td>
                    <td>{{newValue.email}}</td>
                </tr>


                <tr>
                    <th>Alternative email address</th>
                    <td>{{oldValue.email_alt}}</td>
                    <td>{{newValue.email_alt}}</td>
                </tr>


                <tr>
                    <th>Phone number</th>
                    <td>{{oldValue.phone_number}}</td>
                    <td>{{newValue.phone_number}}</td>
                </tr>

                <tr>
                    <th>Alternative phone number</th>
                    <td>{{oldValue.phone_number_alt}}</td>
                    <td>{{newValue.phone_number_alt}}</td>
                </tr>

                <tr>
                    <th>Practice number</th>
                    <td>{{oldValue.practice_number}}</td>
                    <td>{{newValue.practice_number}}</td>
                </tr>

                <tr>
                    <th>VAT registration number</th>
                    <td>{{oldValue.vat_registration_number}}</td>
                    <td>{{newValue.vat_registration_number}}</td>
                </tr>

                <tr>
                    <th>Address ID</th>
                    <td>{{oldValue.address_id}}</td>
                    <td>{{newValue.address_id}}</td>
                </tr>

                <tr>
                    <th>Primary contact ID</th>
                    <td>{{oldValue.primary_contact_id}}</td>
                    <td>{{newValue.primary_contact_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.CompanyType">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Type</th>
                    <td>{{oldValue.type}}</td>
                    <td>{{newValue.type}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>


            </table>

            <table *ngSwitchCase="EntityType.DeliveryType">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Type</th>
                    <td>{{oldValue.type}}</td>
                    <td>{{newValue.type}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.DosageType">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Type</th>
                    <td>{{oldValue.type}}</td>
                    <td>{{newValue.type}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.dosage_unit_id}}</td>
                    <td>{{newValue.dosage_unit_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.DosageUnit">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Unit</th>
                    <td>{{oldValue.unit}}</td>
                    <td>{{newValue.unit}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Symbol</th>
                    <td>{{oldValue.symbol}}</td>
                    <td>{{newValue.symbol}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.Individual">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Profile number</th>
                    <td>{{oldValue.profile_number}}</td>
                    <td>{{newValue.profile_number}}</td>
                </tr>

                <tr>
                    <th>First name</th>
                    <td>{{oldValue.first_name}}</td>
                    <td>{{newValue.first_name}}</td>
                </tr>

                <tr>
                    <th>Last name</th>
                    <td>{{oldValue.last_name}}</td>
                    <td>{{newValue.last_name}}</td>
                </tr>

                <tr>
                    <th>Gender</th>
                    <td>{{oldValue.gender}}</td>
                    <td>{{newValue.gender}}</td>
                </tr>

                <tr>
                    <th>Title</th>
                    <td>{{oldValue.title}}</td>
                    <td>{{newValue.title}}</td>
                </tr>

                <tr>
                    <th>Initials</th>
                    <td>{{oldValue.initials}}</td>
                    <td>{{newValue.initials}}</td>
                </tr>

                <tr>
                    <th>Dependant number</th>
                    <td>{{oldValue.dependant_number}}</td>
                    <td>{{newValue.dependant_number}}</td>
                </tr>

                <tr>
                    <th>Date of birth</th>
                    <td>{{oldValue.date_of_birth}}</td>
                    <td>{{newValue.date_of_birth}}</td>
                </tr>

                <tr>
                    <th>Is an animal</th>
                    <td>{{oldValue.is_animal === 1 ? 'Yes': 'No'}}</td>
                    <td>{{newValue.profile_number}}</td>
                </tr>

                <tr>
                    <th>Email</th>
                    <td>{{oldValue.email}}</td>
                    <td>{{newValue.email}}</td>
                </tr>

                <tr>
                    <th>Alternative email</th>
                    <td>{{oldValue.email_alt}}</td>
                    <td>{{newValue.email_alt}}</td>
                </tr>

                <tr>
                    <th>Phone number</th>
                    <td>{{oldValue.phone_number}}</td>
                    <td>{{newValue.phone_number}}</td>
                </tr>

                <tr>
                    <th>Alternative phone number</th>
                    <td>{{oldValue.phone_number_alt}}</td>
                    <td>{{newValue.phone_number_alt}}</td>
                </tr>


                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>


                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.IndividualType">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Type</th>
                    <td>{{oldValue.type}}</td>
                    <td>{{newValue.type}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.dosage_unit_id}}</td>
                    <td>{{newValue.dosage_unit_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.Medicine">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Name</th>
                    <td>{{oldValue.name}}</td>
                    <td>{{newValue.name}}</td>
                </tr>

                <tr>
                    <th>Active ingredient</th>
                    <td>{{oldValue.active_ingredient}}</td>
                    <td>{{newValue.active_ingredient}}</td>
                </tr>

                <tr>
                    <th>Active ingredient nappy code</th>
                    <td>{{oldValue.active_ingredient_nappy_code}}</td>
                    <td>{{newValue.active_ingredient_nappy_code}}</td>
                </tr>

                <tr>
                    <th>Barcode prefix</th>
                    <td>{{oldValue.barcode_prefix}}</td>
                    <td>{{newValue.barcode_prefix}}</td>
                </tr>

                <tr>
                    <th>Description</th>
                    <td>{{oldValue.description}}</td>
                    <td>{{newValue.description}}</td>
                </tr>

                <tr>
                    <th>Schedule status</th>
                    <td>{{oldValue.schedule_status}}</td>
                    <td>{{newValue.schedule_status}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>


            </table>

            <table *ngSwitchCase="EntityType.MedicineDosagePackageType">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Quantity</th>
                    <td>{{oldValue.contained_quantity}}</td>
                    <td>{{newValue.contained_quantity}}</td>
                </tr>

                <tr>
                    <th>MedicineDosageType ID</th>
                    <td>{{oldValue.medicine_dosage_type_id}}</td>
                    <td>{{newValue.medicine_dosage_type_id}}</td>
                </tr>

                <tr>
                    <th>PackageType ID</th>
                    <td>{{oldValue.package_type_id}}</td>
                    <td>{{newValue.package_type_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>


            </table>

            <table *ngSwitchCase="EntityType.Order">
                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Barcode</th>
                    <td>{{oldValue.barcode}}</td>
                    <td>{{newValue.barcode}}</td>
                </tr>

                <tr>
                    <th>Order status ID</th>
                    <td>{{oldValue.order_status_id}}</td>
                    <td>{{newValue.order_status_id}}</td>
                </tr>

                <tr>
                    <th>Client ID</th>
                    <td>{{oldValue.client_id}}</td>
                    <td>{{newValue.client_id}}</td>
                </tr>

                <tr>
                    <th>Patient ID</th>
                    <td>{{oldValue.patient_id}}</td>
                    <td>{{newValue.patient_id}}</td>
                </tr>

                <tr>
                    <th>ShippingDetails ID</th>
                    <td>{{oldValue.shipping_details_id}}</td>
                    <td>{{newValue.shipping_details_id}}</td>
                </tr>

                <tr>
                    <th>Parent Order ID</th>
                    <td>{{oldValue.parent_order_id}}</td>
                    <td>{{newValue.parent_order_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.OrderItem">
                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Total quantity</th>
                    <td>{{oldValue.total_quantity}}</td>
                    <td>{{newValue.total_quantity}}</td>
                </tr>

                <tr>
                    <th>Price per item</th>
                    <td>{{oldValue.price_per_item}}</td>
                    <td>{{newValue.price_per_item}}</td>
                </tr>

                <tr>
                    <th>OrderItemStatus ID</th>
                    <td>{{oldValue.order_item_status_id}}</td>
                    <td>{{newValue.order_item_status_id}}</td>
                </tr>

                <tr>
                    <th>Order ID</th>
                    <td>{{oldValue.order_id}}</td>
                    <td>{{newValue.order_id}}</td>
                </tr>


            </table>

            <table *ngSwitchCase="EntityType.OrderItemStatus">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Status</th>
                    <td>{{oldValue.status}}</td>
                    <td>{{newValue.status}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.dosage_unit_id}}</td>
                    <td>{{newValue.dosage_unit_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>
            </table>

            <table *ngSwitchCase="EntityType.PackageType">

                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Type</th>
                    <td>{{oldValue.type}}</td>
                    <td>{{newValue.type}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.code}}</td>
                    <td>{{newValue.code}}</td>
                </tr>

                <tr>
                    <th>Code</th>
                    <td>{{oldValue.dosage_unit_id}}</td>
                    <td>{{newValue.dosage_unit_id}}</td>
                </tr>

                <tr>
                    <th>Created</th>
                    <td>{{oldValue.created_at}}</td>
                    <td>{{newValue.created_at}}</td>
                </tr>

                <tr>
                    <th>Updated</th>
                    <td>{{oldValue.updated_at}}</td>
                    <td>{{newValue.updated_at}}</td>
                </tr>

                <tr>
                    <th>Deleted</th>
                    <td>{{oldValue.deleted_at}}</td>
                    <td>{{newValue.deleted_at}}</td>
                </tr>

            </table>

            <table *ngSwitchCase="EntityType.ShippingDetails">
                <tr>
                    <td>&nbsp;</td>
                    <th>Old value</th>
                    <th>New value</th>
                </tr>

                <tr>
                    <th>id</th>
                    <td>{{oldValue.id}}</td>
                    <td>{{newValue.id}}</td>
                </tr>

                <tr>
                    <th>Waybill number</th>
                    <td>{{oldValue.waybill_number}}</td>
                    <td>{{newValue.waybill_number}}</td>
                </tr>

                <tr>
                    <th>Address ID</th>
                    <td>{{oldValue.address_id}}</td>
                    <td>{{newValue.address_id}}</td>
                </tr>

                <tr>
                    <th>DeliveryType ID</th>
                    <td>{{oldValue.delivery_type_id}}</td>
                    <td>{{newValue.delivery_type_id}}</td>
                </tr>

            </table>
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>Close</button>
</div>